import { Component, OnInit } from '@angular/core';
import { QualtricsService } from 'src/app/service/qualtrics/qualtrics.service';

@Component({
  selector: 'cx-qualtrics',
  template: '',
})
export class QualtricsComponent implements OnInit {
  qualtricsScript: string;
  constructor(protected qualtricsLoader: QualtricsService) {
    this.qualtricsLoader.getQualtrics().subscribe((result) => {
      if (result && result.length > 0) {
        const s1 = document.createElement('script');
        const s0 = document.getElementsByTagName('script')[0];
        s1.async = true;
        s1.src = `https://${result[1].value}.siteintercept.qualtrics.com/SIE/?Q_ZID=${result[0].value}`;
        // tslint:disable-next-line: deprecation
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
      }
    });
  }

  ngOnInit() {
    console.log('QSI Survey loaded!');
  }
}
